<template>
  <div class="video-view-normal-box">
    <ul :class="{'show-flex-box-c':true,'clear-screen-style':clearScreen,'full-screen-style':isFull}">
      <li v-if="poster && !progressPoint" class="cover-box">
        <span class="show-flex-box-r">
          <img :src="poster">
        </span>
      </li>
      <li class="top-button-box">
        <div class="control-button-box show-flex-box-r">
          <span v-if="showClose" class="close-button-box"  @click.stop="clickControlButton('goBack')"></span>
          <strong></strong>
          <span v-if="showSwitchAudio" class="audio-button-box"  @click.stop="clickControlButton('switchAudio')"></span>
        </div>
      </li>
      <li v-show="multiplierShowStatus" class="multiplier-choose-list-box">
        <multiplier-speed-float :isShow="multiplierShowStatus"
                                @clickInfo="getMultiplierClickInfo"/>
      </li>
      <li class="center-control-box" @click.stop="clickControlButton('centerControl')"></li>
      <li class="bottom-show-box">
        <div v-if="tryWatchTime" class="try-watch-to-pay-box show-flex-box-r">
          <span class="show-flex-box-r" @click.stop="clickControlButton('tryWatchPayment')">
            <!--  :class="getTryWatchBoxShowClassName()" -->
            <em>可试看{{ tryWatchTime }}，</em>
            <strong>进入APP查看完整内容></strong>
          </span>
        </div>
        <div class="bottom-bar-control-box">
          <ol class="show-flex-box-r">
            <li class="play-pause-button show-flex-box-r show-flex-center" @click.stop="clickControlButton('playPause')">
              <span :class="`status-style-${isPause ? 'play' : 'pause'}`"></span>
            </li>
            <li class="progress-box show-flex-box-r show-flex-center">
              <normal-progress-bar :bannedControl="bannedControl"
                                   :progressPoint="progressPoint"
                                   :initStyle="isFull"
                                   @touchInfo="getProgressData"/>
            </li>
            <li class="merge-time-box show-flex-box-r show-flex-center">
              <span>{{times}}</span>
              <em>/</em>
              <span>{{duration}}</span>
            </li>
            <li class="multiplier-speed-button-box show-flex-box-r show-flex-center" @click.stop="clickControlButton('multiplier')">
              <strong>倍速</strong>
            </li>
            <li class="full-screen-button-box show-flex-box-r show-flex-center" @click.stop="clickControlButton('fullScreen')">
              <span :class="`status-style-${isFull ? 'full' : 'small'}`"></span>
            </li>
          </ol>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

// 组件 start
import normalProgressBar from '@/components/video_player/child/progress_normal_bar'; 
import multiplierSpeedFloat from '@/components/video_player/child/multiplier_speed_float';
// 组件 end

export default {
  props: {
    bannedControl: [Boolean],
    isWaiting:[Boolean],
    isPause: {
      type: Boolean,
      default: true,
    },
    poster: [String],
    times: [String],
    duration: [String],
    isFull: [Boolean],
    showClose: [Boolean],
    showSwitchAudio: [Boolean],
    clearScreen: [Boolean],
    hideControls: [Boolean],
    progressPoint: [Number], // 0 - 1
    tryWatchTime: [Number, String]
  },
  components: {
    normalProgressBar,
    multiplierSpeedFloat,
  },
  data(){
    return {
      multiplierShowStatus: false, // 倍速显示状态
      reloadProgressStatus: true,
    }
  },
  watch: {
    
  },
  mounted() {
    
  },
  methods: {
    // 进度 start
    getProgressData: function(touchInfo) {
      this.sendProgressStatus(touchInfo);
    },
    // 进度 end
    // 倍速 start
    getMultiplierClickInfo: function(clickInfo) {
      const buttonType = clickInfo.buttonType;

      setTimeout(()=>{
        this.multiplierShowStatus = false;
      },300)
      
      switch (buttonType) {
        case 'closeMultiple':
        break;
        case 'selectedMultiple': 
          this.handleControlInfo(clickInfo);
        break;
      }
    },
    // 控制按钮 start
    clickControlButton: function(buttonType) {
      if (this.bannedControl) {
        return;
      }

      let clickInfo = {
        buttonType: buttonType,
      };

      switch (buttonType) {
        case 'multiplier':
          this.multiplierShowStatus = true;
        break;
      }

      this.handleControlInfo(clickInfo);
    },
    handleControlInfo: function(controlInfo) {
      this.sendClickControlInfo(controlInfo);
    },
    // 控制按钮 end
    sendProgressStatus: function(progress) {
      this.$emit('progressChange',progress)
    },
    sendClickControlInfo: function(clickInfo) {
      this.$emit('clickInfo',clickInfo);
    },
  },
};
</script>

<style lang="less">
  .video-view-normal-box {
    overflow: hidden;
    height: 100%;
    &>ul {
      position: relative;
      height: 100%;
      &>.cover-box {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        &>span {
          width: 100%;
          height: 100%;
          &>img {
            display: block;
            width: 100%;
            height: 100%;
            flex-grow: 1;
            object-fit: cover;
          }
        }
      }
      &>.top-button-box {
        position: absolute;
        top: 0;
        z-index: 3;
        justify-content: flex-end;
        width: 100%;
        background:linear-gradient(0deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0.5) 100%);
        transition: all 0.3s ease;
        transform: translateY(0);
        &>.control-button-box {
          &>strong {
            flex-grow: 1;
          }
          &>span {
            display: block;
            flex-shrink: 0;
            width: 0.2rem;
            height: 0.2rem;
            padding: 0.15rem;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: 0.2rem 0.2rem;
          }
          &>.close-button-box {
            // background-image: url('../../../../assets/header/white-back_icon.png');
          }
          &>.audio-button-box {
            // background-image: url('../../../../assets/video/audio_button_1.png');
            background-image: url('../../../../assets/video/audio_button_1.png');
          }
        }
      }
      &>.multiplier-choose-list-box {
        position: absolute;
        z-index: 4;
        width: 100%;
        height: 100%;
      }
      &>.center-control-box {
        height: 100%;
      }
      &>.bottom-show-box {
        position: absolute;
        bottom: 0;
        z-index: 3;
        width: 100%;
        transform: translateY(0);
        transition: all 0.3s ease;
        &>.try-watch-to-pay-box {
          padding-left: 0.15rem;
          &>span {
            font-size: 13px;
            padding: 5px 10px;
            border: 1px solid #fff;
            border-radius: 30px;
            transition: all 0.2s ease;
            background: rgba(0, 0, 0, 0.3);
            &>em {
              display: block;
              overflow: hidden;
              white-space: nowrap;
              // width: 72px;
              transition: all 0.2s ease;
              color: #fff;
            }
            &>strong {
              display: block;
              white-space: nowrap;
              color: #DABB71;
            }
          }
          &>.try-watch-time-hide {
            margin-bottom: 0.1rem;
            background: rgba(0, 0, 0, 0.5);
            border: 1px solid #DABB71;
            &>em {
              width: 0px;
            }
          }
        }
        &>.bottom-bar-control-box {
          // transform: translateY(0);
          // transition: all 0.3s ease;
          background:linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0.5) 100%);
          &>ol {
            width: 100%;
            height: 0.4rem;
            &>li {
              flex-shrink: 0;
            }
            &>.play-pause-button {
              padding-left: 0.15rem;
              padding-right: 0.15rem;
              &>span {
                display: block;
                width: 0.15rem;
                height: 0.15rem;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: 100% 100%;
              }
              &>.status-style-play {
                background-image: url('../../../../assets/video/video_bar_play_1.png');
              }
              &>.status-style-pause {
                background-image: url('../../../../assets/video/video_bar_pause_1.png');
              }
            }
            &>.progress-box {
              flex-grow: 1;
            }
            &>.merge-time-box {
              min-width: 0.95rem;
              justify-content: flex-end;
              &>span,&>em {
                display: block;
                font-size: 0.14rem;
                font-family: PingFangSC-Regular;
                line-height: 0.2rem;
                white-space: nowrap;
                color: #FFFFFF;
              }
              &>span {

              }
              &>em {

              }
            }
            &>.multiplier-speed-button-box {
              padding-left: 0.12rem;
              padding-right: 0.06rem;
              &>strong {
                display: block;
                font-size: 0.14rem;
                font-family: PingFangSC-Regular;
                line-height: 0.2rem;
                color: #FFFFFF;
              }
            }
            &>.full-screen-button-box {
              padding-right: 0.15rem;
              padding-left: 0.06rem;
              &>span {
                width: 0.16rem;
                height: 0.16rem;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: 100% 100%;
              }
              &>.status-style-full {
                background-image: url('../../../../assets/video/video_full_screen_no_1.png');
              }
              &>.status-style-small {
                background-image: url('../../../../assets/video/video_full_screen.png');
              }
            }
          }
          &>.footer-placeholer-box {
            padding-bottom: 0.12rem;
          }
        }
      }
    }
    &>.clear-screen-style {
      &>.top-button-box {
        transform: translateY(-100%);
      }
      &>.bottom-show-box {
        transform: translateY(0.4rem);
        &>.try-watch-to-pay-box {
          margin-bottom: 0.1rem;
        }
        // &>.bottom-bar-control-box {
        //   transform: translateY(100%);
        // }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/video_player/view/video/video_view_normal.vue